import { apiDomain } from "env";

const cancelarMovimento = (id = "") =>
  `${apiDomain("portal/beneficiario")}/movimentos/${id}/cancelar`;

const cancelarMovimentos = () =>
  `${apiDomain("portal/beneficiario")}/movimentos/cancelar`;

const enviarMovimentoParaAuditoria = movimentoId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/movimentos/${movimentoId}/enviar_para_auditoria`;

const enviarMovimentoParaAuditoriaQueue = movimentoId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/movimentos/queue/${movimentoId}/enviar_para_auditoria`;

const exclusaoSolicBeneficiarioRascunho = `${apiDomain(
  "portal/beneficiario"
)}/exclusoes_solicitadas_beneficiario`;

const getCodigosBancos = `${apiDomain(
  "portal/beneficiario"
)}/exclusoes_solicitadas_beneficiario/codigos_bancos`;

const getDadosBancariosExclusao = beneficiarioCartao =>
  `${apiDomain(
    "portal/beneficiario"
  )}/exclusoes_solicitadas_beneficiario/${beneficiarioCartao}`;

const getFamiliaBeneficiarioParaExclusao = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/exclusoes_solicitadas_beneficiario/familia/exclusoes?codigoBeneficiario=${codigoBeneficiario}`;

const getFamiliaCompleta = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/beneficiarios/familia/codigoBeneficiario/${codigoBeneficiario}`;

const getLogoCartao = `${apiDomain("portal/beneficiario")}/empresas/logotipo`;

const graphql = `${apiDomain("portal/beneficiario")}/graphql`;

const movimentoAlteracao = tipo =>
  `${apiDomain(
    "portal/beneficiario"
  )}/inclusao_alteracao_beneficiarios/alteracao/${tipo}`;

const downloadAnexoMovimento = movimentoArquivoId =>
  `${apiDomain(
    "portal/beneficiario"
  )}/movimento_anexos/${movimentoArquivoId}/download`;

const removerAnexo = arquivoId =>
  `${apiDomain("portal/beneficiario")}/movimento_anexos/${arquivoId}/remover`;

const movimentosDuplicados = ({
  codigoBeneficiario = "",
  tipoMovimentoId = "",
  cpf = "",
  nomeBeneficiario = "",
  nomeMae = "",
  dataNascimento = "",
  sexoId = "",
  sistemaIntegracaoId = "",
  codigoEmpresa = ""
}) =>
  `${apiDomain("portal/beneficiario")}/movimento_beneficiarios/verificar` +
  `?codigoBeneficiario=${codigoBeneficiario}` +
  `&tiposMovimentoId=${tipoMovimentoId}` +
  `&cpf=${cpf}` +
  `&nomeBeneficiario=${nomeBeneficiario}` +
  `&nomeMae=${nomeMae}` +
  `&dataNascimento=${dataNascimento}` +
  `&sexoId=${sexoId}` +
  `&sistemaIntegracaoId=${sistemaIntegracaoId}` +
  `&codigoEmpresa=${codigoEmpresa}`;

const movimentoPrepararEnvio = (tipoMovimento, id) =>
  `${apiDomain("portal/beneficiario")}/${tipoMovimento}/${id}/preparar_envio`;

const saveExclusaoSolicBeneficiario = id =>
  `${apiDomain(
    "portal/beneficiario"
  )}/exclusoes_solicitadas_beneficiario/${id}`;

const segundaViaCriarRascunho = () =>
  `${apiDomain("portal/beneficiario")}/segunda_via_cartoes/criar_rascunho`;

const listarTiposRecebimentoBoletos = `${apiDomain(
  "portal/beneficiario"
)}/tipos_recebimento_boleto`;

const updateMovimentoAlteracao = () =>
  `${apiDomain("portal/beneficiario")}/inclusao_alteracao_beneficiarios`;

const cadastrarAnexo = (tipoAnexoId = "", movimentoId = "") =>
  `${apiDomain(
    "portal/beneficiario"
  )}/movimento_anexos/${tipoAnexoId}/${movimentoId}/cadastrar`;

const motivosExclusao = dependente =>
  `${apiDomain("portal/beneficiario")}/motivos_exclusao/listar${
    dependente ? "?dependente=true" : "?titular=true"
  }`;

const nivelEnderecoBeneficiario = `${apiDomain(
  "portal/beneficiario"
)}/pessoas_enderecos/nivel_endereco_beneficiario`;

const enderecoBeneficiario = (codigoBeneficiario, pessoaId) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/pessoas_enderecos/beneficiario?codigoBeneficiario=${codigoBeneficiario}&pessoaId=${pessoaId}`;

const benefTemMovInclusaoAlteracaoAberto = (
  codigoBeneficiario,
  codigoBeneficiarioTitular,
  movimentoId = null
) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/movimento_beneficiarios/verificar_alteracao_inclusao_aberto?codigoBeneficiario=${codigoBeneficiario}&codigoBeneficiarioTitular=${codigoBeneficiarioTitular}${
    movimentoId ? `&movimentoId=${movimentoId}` : ""
  }`;

export default {
  cancelarMovimento,
  cancelarMovimentos,
  enviarMovimentoParaAuditoria,
  enviarMovimentoParaAuditoriaQueue,
  exclusaoSolicBeneficiarioRascunho,
  getCodigosBancos,
  getDadosBancariosExclusao,
  getFamiliaBeneficiarioParaExclusao,
  getFamiliaCompleta,
  getLogoCartao,
  graphql,
  movimentoAlteracao,
  downloadAnexoMovimento,
  removerAnexo,
  movimentosDuplicados,
  movimentoPrepararEnvio,
  saveExclusaoSolicBeneficiario,
  segundaViaCriarRascunho,
  updateMovimentoAlteracao,
  cadastrarAnexo,
  motivosExclusao,
  nivelEnderecoBeneficiario,
  enderecoBeneficiario,
  listarTiposRecebimentoBoletos,
  benefTemMovInclusaoAlteracaoAberto
};
